import consts from "@/consts"
import {updateObjectByDiff, getApiProps} from "@/lib/lib";
// import {objectComparison} from "@/lib/lib";
const changedField = 'changed__time';
const collator = new Intl.Collator();
const sortByName = function (a, b) {
    let cmp = collator.compare(a?.name_ || '', b?.name_ || '')
    if (cmp) {
        return cmp;
    }
    return a.id - b.id;
}

export default {
    state: {
        notificationsGroups: [],

        notificationsFullLoad: false,
        notifications: [],
    },
    actions: {
        fetchNotificationsGroups({commit, dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchNotificationsGroups', args, time: Date.now() / 1000})

                const params = getApiProps('notifications_groups', args)
                this.$api.notifications.getAllGroups(params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateNotificationsGroups', response.data)
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchNotificationsGroups', args, inprogress: false})
                    });
            })
        },

        fetchNotifications/*all*/({dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchNotifications', args, time: Date.now() / 1000})

                const params = getApiProps('notifications', args)
                this.$api.notifications.getAll({...params})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchNotifications', args, inprogress: false})
                    });
            })
        },
        fetchNotificationsAll({dispatch, commit, getters}, args) {
            dispatch('setLastCall', {name: 'fetchNotificationsAll', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchNotificationsChanged', args, time: Date.now() / 1000})

            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(null)
                }
                dispatch('fetchNotifications', {lite: true, ...args})
                    .then((data) => {
                        commit('setNotifications', data)
                        commit('setNotificationsFullLoad', true)
                        resolve(data.length)
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchNotificationsAll', {})
                        }, 60 * 1000)
                    })
            })
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchNotificationsAll', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchNotificationsChanged', args, inprogress: false})
                });
        },
        fetchNotificationsChanged({dispatch, commit, getters}, args) {
            if (!getters.getApiToken || !getters.isNotificationsFullLoad) {
                return Promise.resolve(null)
            }
            dispatch('setLastCall', {name: 'fetchNotificationsChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            return dispatch('fetchNotifications', args)
                .then((data) => {
                    commit('updateNotifications', data)
                    return dispatch('fetchNotifications', {fields: 'id', expand: ''})
                })
                .then((data) => {
                    commit('filterNotifications', data)
                })
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchNotificationsChanged', args, inprogress: false})
                });
        },
        fetchFavoritesNotifications({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchFavoritesNotifications', args, time: Date.now() / 1000})

                dispatch('fetchNotifications', {filter: {favorites: true}})
                    .then((data) => {
                        commit('updateNotifications', data)
                        resolve(true)
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchFavoritesNotifications', args, inprogress: false})
                    });
            })
        },
        reloadNotificationsAll({commit, dispatch}, args) {
            commit('clearNotifications')
            return dispatch('fetchNotificationsAll', args)
                .then(() => {
                    //dispatch('fetchNotificationsAllPages', args)
                })
        },

        //actions
        saveNotificationAction(context, args) {
            return new Promise((resolve, reject) => {
                if(!args?.notifId) {
                    return reject(false)
                }
                this.$api.notifications.patchActions(args.notifId, {status: args.enabled})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                        //resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },

        //geozones
        saveNotificationGeozone(context, args) {
            return new Promise((resolve, reject) => {
                let action = (args.enabled === true) ? 'add' : 'remove'
                this.$api.notifications.patchGeozones(args.notifId, action, {id_geozone: args.id_geozone})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                        //resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        //geopoints
        saveNotificationGeopoint(context, args) {
            return new Promise((resolve, reject) => {
                let action = (args.enabled === true) ? 'add' : 'remove'
                this.$api.notifications.patchGeopoints(args.notifId, action, {id_geopoint: args.id_geopoint})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                        //resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        //units
        saveNotificationUnit(context, args) {
            return new Promise((resolve, reject) => {
                let action = (args.enabled === true) ? 'add' : 'remove'
                this.$api.notifications.patchUnits(args.notifId, action, {id_unit: args.id_unit})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                        //resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        //unit-groups
        saveNotificationUnitGroup(context, args) {
            return new Promise((resolve, reject) => {
                let action = (args.enabled === true) ? 'add' : 'remove'
                this.$api.notifications.patchUnitGroups(args.notifId, action, {id_group: args.id_group})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                        //resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        //sensors
        saveNotificationSensor(context, args) {
            return new Promise((resolve, reject) => {
                let action = (args.enabled === true) ? 'add' : 'remove'
                this.$api.notifications.patchSensors(args.notifId, action, {id_sensor: args.id_sensor})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                        //resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        //routes
        saveNotificationRoute(context, args) {
            return new Promise((resolve, reject) => {
                let action = (args.enabled === true) ? 'add' : 'remove'
                this.$api.notifications.patchRoutes(args.notifId, action, {id_route: args.id_route})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                        //resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        //drivers
        saveNotificationDriver(context, args) {
            return new Promise((resolve, reject) => {
                let action = (args.enabled === true) ? 'add' : 'remove'
                this.$api.notifications.patchDrivers(args.notifId, action, {id_driver: args.id_driver})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                        //resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        //'unit-documents'
        //'driver-documents'


        //sayHello() {}
    },
    mutations: {
        setNotificationsFullLoad(state, FullLoad) {
            state.notificationsFullLoad = state.notificationsFullLoad || FullLoad
        },
        setNotifications(state, nNotifs) {
            nNotifs = nNotifs.map(n => {
                if (n?.name) n.name_ = n.name.toLocaleLowerCase()
                return n //Object.freeze(n)
            })
            nNotifs.sort(sortByName)
            state.notifications = nNotifs
        },
        updateNotifications(state, nNotifs) {
            if (!state.notifications.length) {
                nNotifs = nNotifs.map(n => {
                    if (n?.name) n.name_ = n.name.toLocaleLowerCase()
                    return n //Object.freeze(n)
                })
                nNotifs.sort(sortByName)
                state.notifications = nNotifs
                // const chunks = arraySplitIntoChunks(nNotifs)//.reverse();
                // const pushOnRenderTask = () => {
                //     if (chunks.length === 0) return;
                //     let chunk = chunks.pop();
                //     state.notifications.push(...chunk);
                //     setTimeout(() => {
                //     requestAnimationFrame(pushOnRenderTask);
                //     }, 300)
                //     //this.$nextTick().then(() => pushOnRenderTask())
                // }
                // pushOnRenderTask();
                return true
            }

            nNotifs.forEach(nNotif => {
                if (nNotif?.name) nNotif.name_ = nNotif.name.toLocaleLowerCase()
                let i = state.notifications.findIndex(oNotif => oNotif.id == nNotif.id)
                if (i < 0) {
                    state.notifications.push(nNotif)
                } else
                if (!state.notificationsFullLoad || state.notifications[i][changedField] != nNotif[changedField]) {
                    updateObjectByDiff(state.notifications[i], nNotif)
                    // delete nNotif.id
                    // state.notifications[i] = {...state.notifications[i], ...nNotif}
                }
            })
        },
        filterNotifications(state, notifications) {
            let nIds = notifications.map(n => n.id)
            let removedIds = state.notifications
                .filter(n => !n.json_data.special)
                .filter(n => !nIds.includes(n.id)).map(n => n.id)
            removedIds.forEach(removedId => {
                let i = state.notifications.findIndex(n => (n.id == removedId))
                if (i != -1) {
                    state.notifications.splice(i, 1)
                }
            })
        },
        clearNotifications(state) {
            state.notifications = []
            state.notificationsFullLoad = false
        },
    },
    getters: {
        isNotificationsFullLoad(state) {
            return state.notificationsFullLoad
        },

        getNotifications(state) {
            return state.notifications.filter(n => !n?.json_data?.special)
        },
        getSystemNotifications(state) {
            return state.notifications.filter(n => n?.json_data?.special)
        },
        getNotificationsByIds(state) {
            return state.notifications
                .reduce((notificationsByIds, notification) => {
                    notificationsByIds[notification.id] = notification
                    return notificationsByIds
                }, {})
        },
        getNotificationsGroups(state) {
            return state.notificationsGroups
        },
    }
}
